// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const headerLogo = document.querySelector('.js-scroll-logo');
const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerMenuClose = document.getElementById('js-close-menu');
const burgerMenu = document.getElementById('burger-menu');
const primaryNav = document.querySelectorAll('#primary-nav li');

(function(){

	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	/* Main Nav */


	burgerMenu.addEventListener('click', (e) =>{
		if(e.target.classList.contains('open')){
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		}
	})

	burgerMenuBtn.addEventListener('click', () =>{
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll');
	});

	burgerMenuClose.addEventListener('click', () =>{
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll');
	});

	primaryNav.forEach(primary => {
		if(primary.querySelector('.submenu')){
			primary.classList.add('li-sub');
			primary.querySelector('a').addEventListener("click", (event) => {
				event.preventDefault();

			});
		}

		let link = primary.querySelector('a').getAttribute('href');
		if(link.includes('#')) {
			primary.querySelector('a').addEventListener("click", () => {
				burgerMenu.classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}
	});

	document.querySelectorAll("#primary-nav > li.li-sub").forEach(item => {
		item.addEventListener("click", function() {
			if (!this.classList.contains("hover")) {
				document.querySelectorAll("#primary-nav > li.li-sub.hover").forEach(el => {
					el.classList.remove("hover");
					el.querySelector("ul.submenu").classList.remove('open');
				});

				this.classList.add("hover");
				this.querySelector("ul.submenu").classList.add('open')

			} else {
				this.classList.remove("hover");
				this.querySelector("ul.submenu").classList.remove('open');
			}
		});
	});

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass:'lbx-gallery',
	});
  

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    /* Remove empty <p> tags created by tinymce  */
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	
	
	/* SWIPERS */

	let historySwiper = document.getElementById('history-year');
	if (historySwiper) {
		const yearSwiper = new Swiper('#history-year', {
			allowTouchMove: false,
			centeredSlides: true,
			
			loop: true,
			navigation: {
				nextEl: '.history-next',
				prevEl: '.history-prev'
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
					speed: 300,
				},
				1100: {
					slidesPerView: 3,
					speed: 800
				}
			}
		});
	
		const itemSwiper = new Swiper('#history-item', {
			allowTouchMove: false,
			speed: 800,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
	
		yearSwiper.on('slideChange', function () {
			let activeIndex = this.realIndex;
			itemSwiper.slideTo(activeIndex);
		});


		const button = document.querySelectorAll("#history-year .swiper-slide");
		const historyNext = document.querySelector('.history-next');
		const historyPrev = document.querySelector('.history-prev');

		button.forEach(ele => {
			ele.addEventListener('click', clickAdvance);
		});
	
		function clickAdvance(){
			if(this.classList.contains('swiper-slide-prev')){
				historyPrev.click();
			}
			else if(this.classList.contains('swiper-slide-next')){
				historyNext.click();
			}
		}
	};

	let eventSlider = document.querySelectorAll('.event-slider');
	if(eventSlider){
		const eveSlider = new Swiper('.event-slider', {
			autoplay: {
				delay: 7000,
			},
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.swiper-prev',
				prevEl: '.swiper-next',
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				type: "bullets"
			}
		});
	};

	let listImgSlider = document.querySelectorAll('.list-img-silder');
	if(listImgSlider){
		const liImgSlider = new Swiper('.list-img-silder', {
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.swiper-prev',
				prevEl: '.swiper-next',
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				type: "bullets"
			}
		});
	};

	let sliderSwiper = document.querySelectorAll('.slider-swiper');
	if(sliderSwiper){
		const slideSwiper = new Swiper('.slider-swiper', {
			autoplay: {
				delay: 7000,
			},
			effect: "fade",
			rewind: "true",
			speed: 800,
			fadeEffect: {
				"crossFade": true,
			},
			navigation: {
				nextEl: '.slider-next',
				prevEl: '.slider-prev',
			},
		
			breakpoints: {
				1025: {
					pagination: {
						el: ".slider-pagination",
						clickable: true,
						type: "bullets"
					}
				}
			}
		});
	};
	
	let cardSwiper = document.querySelectorAll('.card-swiper');
	if(cardSwiper){
		const caSwiper = new Swiper('.card-swiper', {
			spaceBetween: 10,
			loop: true,
			rewind:false,
			speed: 800,
			navigation: {
				nextEl: '.card-next',
				prevEl: '.card-prev',
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				700: {
					slidesPerView: 2,
				},
				1025: {
					slidesPerView: 3,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
						type: "bullets",
					}
				}
			}
		});
	};
	
	document.querySelectorAll('.rooms-swiper').forEach((slider, i) => {
		const swiperOps = {
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: `.swiper-next-${i}`,
				prevEl: `.swiper-prev-${i}`,
			},
			breakpoints: {
				1025: {
					pagination: {
						el: `.swiper-pagination-${i}`,
						clickable: true,
						type: "bullets"
					}
				}
			}
		};
		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, swiperOps);
	});

	let gallerySwiper = document.querySelectorAll('.gallery-swiper');
	if(gallerySwiper){
		const glrySwiper = new Swiper('.gallery-swiper', {
			slidesPerView: 1,
			rewind: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.gallery-prev',
				prevEl: '.gallery-next',
			}
		});
	};

	let homeHeroSwiper = document.querySelectorAll('.top-content-swiper');
	if(homeHeroSwiper){
		const heroSwiper = new Swiper('.top-content-swiper', {
			slidesPerView: 1,
			rewind: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			autoplay: {
				"delay": 5000,
				"disableOnInteraction": false
			}
			
		});
	};

	let imgSwiper = document.querySelectorAll('.img-swiper');
	if(imgSwiper){
		const imageSwiper = new Swiper('.img-swiper', {
			autoplay: {
				delay: 6000,
			},
			loop: true,
			effect: "fade",
			speed: 800,
			fadeEffect: {
				"crossFade": true
			},
			navigation: {
				nextEl: '.img-slider-prev',
				prevEl: '.img-slider-next',
			},
		
			breakpoints: {
				1025: {
					pagination: {
						el: ".img-slider-pagination",
						clickable: true,
						type: "bullets"
					}
				}
			}
		});
	};

	let awardsSwiper = document.querySelectorAll('.awards-swiper');
	if(awardsSwiper){
		const awdsSwiper = new Swiper('.awards-swiper', {
			speed: 800,
			navigation: {
				nextEl: '.awards-prev',
				prevEl: '.awards-next',
			},
		
			breakpoints: {
				320: {
					slidesPerView: 1,
					loop: true
				},
				700: {
					slidesPerView: 3,
				},
			}
		});
	};


	let internalGallerySwiper = document.querySelectorAll('.internal-gallery-swiper');
	if(internalGallerySwiper){
		const gallerySwiperInternal = new Swiper('.internal-gallery-swiper', {
			spaceBetween: 20,
			loop:true,
			rewind:false,
			speed: 800,
			autoplay: {
				delay: 5000,
			},
			slidesPerView: 4,
			breakpoints: {
				700: {
				
					pagination: {
						el: ".internal-gallery-pagination",
						clickable: true,
					},
				}
			},
			navigation: {
				nextEl: '.gallery-next',
				prevEl: '.gallery-prev',
				clickable: true,
			},
		});
	};

		
	 /* vanilla JS fancybox */
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allCloseTerms = document.getElementsByClassName('js-close-terms');
		let allTermsLight = document.querySelectorAll('.terms-lbx');
		for(let j = 0; j < allCloseTerms.length; j++ ){
			allCloseTerms[j].addEventListener('click', function(e){
				e.preventDefault();
				allTermsLight.forEach(el => el.classList.remove('open'));
			});
		};

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};

	var dateInputs = document.querySelectorAll('input[type="date"]');
	if (dateInputs.length > 0) {
		dateInputs.forEach(function(input) {
			
			input.addEventListener('click', function() {
				this.classList.add('clicked');
			});
	
		});
	}

	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
	if(aHref){
	   aHref.forEach(function(a_href) {
		   a_href.addEventListener('click', function(e){
			   e.preventDefault();
			   let strAnchor = this.hash.slice(1);
			   animateto(strAnchor);
			   
		   });
	   });
   }

})();

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function onLoad(){

	if(!document.getElementById('gallery') && !document.getElementById('attractions') && document.getElementsByClassName('sitemap').length < 1 && document.getElementsByClassName('terms-and-conditions').length < 1 && document.getElementsByClassName('no-hero').length < 1){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	} else {
		document.getElementById('header').classList.add('scroll');
		if(headerLogo) {
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		}
	}
}

function scrollW(){
	let subNav = document.getElementsByClassName('sub-menu')[0];
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			if(headerLogo) {
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
				
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			if(headerLogo) {
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st;

	if(subNav != undefined){
		if(st > 430){
			document.getElementsByClassName('sub-menu')[0].classList.add('scroll-fix');
		} else {
			document.getElementsByClassName('sub-menu')[0].classList.remove('scroll-fix');
		}
	}


};


const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;
		
		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);
	
		const countDownDate = new Date(date).getTime();
		
		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;
	
			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}
	
			if (dateDiff < 0)
				clearInterval(timerInterval);
		}
	
		timer();
	
		const timerInterval = setInterval(timer, 1000);
	}

}


function animateto(target){
    let gotoTarget = offset(document.getElementById(target)).top - 120;
    let from     = window.pageYOffset
    let to       = gotoTarget
    let duration = 500;
    let start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

} 
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));